import FlexViewBorder from "../../../components/FlexView/FlexViewBorder/FlexViewBorder";
import Separator from "../../../components/Separator";
import TitleBorderLeft from "../../../components/Text/TitleBorderLeft";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";
import TabsViewTwo from "../../../components/tabs/TabsViewTwo/TabsViewTwo";
import FemaleIcon from '../../../assets/icons/social/female.svg';
import FemaleTwoIcon from '../../../assets/icons/social/female-2.svg'
import MonyIcon from '../../../assets/icons/social/mony.svg';
import EducationIcon from '../../../assets/icons/social/education.svg';
import MonyIncrese from '../../../assets/icons/social/increse.svg';
import IncreseTwo from '../../../assets/icons/social/increase-2.svg';
import CupIcon from '../../../assets/icons/social/cup.svg';
import RocketIcon from '../../../assets/icons/social/rocket.svg';
import Academy from '../../../assets/icons/social/academy.svg';
import HandLeave from '../../../assets/icons/social/hande-leave.svg';
import Recycle from '../../../assets/icons/social/recycle.svg';
import SocialIcon2 from '../../../assets/icons/social/social-2.svg';
import Social1 from '../../../assets/images/social/social-1.jpg';
import Social2 from '../../../assets/images/social/social-2.jpg';
import Social3 from '../../../assets/images/social/social-3.jpg';
import Social4 from '../../../assets/images/social/social-4.jpg';
import Social5 from '../../../assets/images/social/social-5.jpg';
import Social6 from '../../../assets/images/social/social-6.jpg';

const tabsViewOneData = [
  <>
    <h2 className="text-title">التنوع</h2>
    <BorderLeftBox
      title="التنوع بين الجنسين لدى بنك الأول"
      subtitle="يُمثل التنوع، خاصة فيما يتعلق بتمكين المرأة، واحداً من المبادئ الخاصة في رؤية 2030. ولا يُعد تطبيق المساواة بين الجنسين مجرد خطوة صحيحة علينا اتخاذها، بل هي خطوة تُسهم كذلك وفق ما توصلت إليه الأبحاث بشكل إيجابي في الارتقاء بمستوى الأداء التنظيمي عن طريق تحسين عمليات حل المشكلات وتوفير فهم أكثر تفصيلاً للمسائل الجوهرية. يُمثل تعزيز التنوع في بنك الأول مهمة تبدأ من أعلى المستويات في البنك، بما في ذلك قيادة مجلس الإدارة ونزولاً إلى جميع المستويات الأخرى في الهيكل التنظيمي. علاوة على ذلك، يمتلك البنك مزيجاً متنوعاً مناسباً من المهارات والقدرات والخبرات على مستوى مجلس الإدارة، حيث يتضمن أعضاءً محليين ودوليين يتمتعون بخبرة متخصصة في القطاعات المالية وغير المالية."
    />
    <h2 className="text-paragraph">
    بنك الأول هو البنك الذي يحمل لواء جهود التنوع بين الجنسين في المملكة، بل في المنطقة:
    </h2>
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : FemaleIcon,
            alt : "",
          },
          spanTwo : "بنك الأول هي أول شركة مدرجة في المملكة العربية السعودية تعين رئيسة لمجلس الإدارة",
        },
        {
          icon : {
            src : FemaleTwoIcon,
            alt : "",
          },
          spanOne : "حققنا في عام 2022 تمثيل المرأة بنسبة",
          number : 35.7,
          unit : "%",
          spanTwo : "في مناصب الإدارة التنفيذية"
        }
      ]}
    />
    <p className="text-paragraph">
    شغلت 5 نساء مناصب ضمن الإدارة التنفيذية خلال عام 2022 في مجالس الإدارة واللجان الفرعية للشركات التابعة والفرعية لبنك الأول. ويستهدف البنك إعداد القيادات النسائية لشغل المناصب بمجلس الإدارة في المستقبل. 
    </p>
    <p className="text-paragraph">يدعم البنك المشاركة الفعالة للموظفات من خلال وضع أهداف طموحة على مستوى جميع وحدات الأعمال. شهدت القوى العاملة في بنك الأول زيادة مطردة في تمثيل الإناث على مدار السنوات القليلة الماضية كما هو موضح أدناه.
    </p>
    <TitleBorderLeft>إحصاءات التنوع بين الجنسين بنهاية العام</TitleBorderLeft>
    <div className="space-25"></div>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary">
      <thead>
        <tr>
          <th aria-hidden="true"><span></span></th>
          <th aria-hidden="true"></th>
          <th className="">2021</th>
          <th aria-hidden="true"></th>
          <th className="">2022</th>
        </tr>
        <tr>
          <th aria-hidden="true"></th>
          <th className="">الذكور</th>
          <th className="">الإناث</th>
          <th className="">الذكور</th>
          <th className="">الإناث</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>مجلس الإدارة</td>
          <td className="">10</td>
          <td className="">1</td>
          <td className=" bg-light-red"><b>10</b> <sup className="red-text a-mark">&#9398;</sup></td>
          <td className=" bg-light-red"><b>1</b> <sup className="red-text a-mark">&#9398;</sup></td>
        </tr>
        <tr>
          <td>الإدارة التنفيذية</td>
          <td className="">9</td>
          <td className="">5</td>
          <td className=" bg-light-red">10</td>
          <td className=" bg-light-red">5</td>
        </tr>
        <tr>
          <td>الإدارة العليا</td>
          <td className="">109</td>
          <td className="">17</td>
          <td className=" bg-light-red">135</td>
          <td className=" bg-light-red">19</td>
        </tr>
        <tr>
          <td>الإدارة المتوسطة والصغرى</td>
          <td className="">2,800</td>
          <td className="">765</td>
          <td className=" bg-light-red">2,731</td>
          <td className=" bg-light-red">809</td>
        </tr>
        <tr>
          <td>إجمالي عدد الموظفين العاملين بدوام كامل</td>
          <td className="">2,918</td>
          <td className="">787</td>
          <td className=" bg-light-red"><b>2,876</b> <sup className="red-text a-mark">&#9398;</sup></td>
          <td className=" bg-light-red"><b>833</b> <sup className="red-text a-mark">&#9398;</sup></td>
        </tr>
      </tbody>
    </table>
    </div>
    <p className="text-note"><sup className="red-text a-mark">&#9398;</sup>  خضع معيار القياس للسنة المنتهية في 31 ديسمبر 2022 لتأكيد محدود مستقل من جانب شركة برايس ووترهاوس كوبرز للمحاسبين القانونيين ("PwC")، وللحصول على تفاصيل إضافية، يُرجى الاطلاع على معايير إعداد التقارير لدينا وتقرير التأكيد المحدود لشركة بي دبليو سي عبر زيارة الموقع الإلكتروني (الرابط).</p>
    <div className="space-50"></div>
    <BorderLeftBox 
      title="إحصاءات التنوع على مدار الوقت: "
      subtitle="العمر والجنس (باستثناء المتدربين والطلاب والموظفين بعقود خارجية)"
    />
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary">
      <thead>
        <tr></tr>
        <tr className="border-bottom-red">
          <th aria-hidden="true"></th>
          <th className="">2020</th>
          <th className="">2021</th>
          <th className="">2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>الموظفون بعمر 18-30 عاماً</td>
          <td className="">384</td>
          <td className="">485</td>
          <td className=" bg-light-red">615</td>
        </tr>
        <tr>
          <td>الموظفون بعمر 31-50 عاماً</td>
          <td className="">3,241</td>
          <td className="">3,036</td>
          <td className=" bg-light-red">2,891</td>
        </tr>
        <tr>
          <td>الموظفون بعمر أكثر من 51 عاماً</td>
          <td className="">429</td>
          <td className="">184</td>
          <td className=" bg-light-red">203</td>
        </tr>
        <tr>
          <td>الموظفون من الذكور</td>
          <td className="">3,248</td>
          <td className="">2,918</td>
          <td className=" bg-light-red">2,876</td>
        </tr>
        <tr>
          <td>الموظفات من الإناث</td>
          <td className="">806</td>
          <td className="">787</td>
          <td className=" bg-light-red">833</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>برامج تمكين المرأة</TitleBorderLeft>
    <p className="text-paragraph">يُمثل إدراج المرأة بما يتماشى مع مبدأ التنوع في استراتيجيتنا الخاصة بالحوكمة البيئية والاجتماعية والمؤسسية قضية دائمة تُراعى في جميع مبادراتنا الرئيسية سواء على المستوى الداخلي بالبنك أو الخارجي من خلال مساهماتنا المجتمعية. وانطلاقاً من ذلك، فقد أسسنا مجموعة متنوعة من البرامج الاجتماعية لتمكين المرأة.</p>
    <p className="text-paragraph">يواصل البنك في الوقت ذاته جهود التعاون المبذولة مع جمعية النهضة من أجل دعم المرأة في إطار الاستراتيجية التي تستهدف تحسين مستوى الوعي المالي على مستوى المملكة.جمعية النهضة هي منظمة غير ربحية تأسست في عام 1963 وتكرس جهودها لتحقيق التمكين الاجتماعي والاقتصادي للمرأة.</p>
    <p className="text-paragraph">يستهدف مشروع خزنة نشر الوعي المالي بين النساء لتشجيعهن على الاستقلال المالي، وذلك من خلال توفير مهارات التدريس التي تساعد النساء على التخطيط للشؤون المالية والإنفاق مع العمل في الوقت ذاته على تعلم سلوكيات جديدة تساعدهن على إدارة الشؤون المالية بشكل يومي.</p>
    <FlexViewBorder 
      items={[
        // {
        //   icon : {
        //     src : MonyIcon,
        //     alt : "",
        //   },
        //   spanTwo : "Al-Nahda project outcomes",
        // },
        {
          number : 124,
          spanTwo : "مشاركاً من ذوي الدخل المنخفض في عام 2022",
        },{
          number : 6,
          spanTwo : "جلسات تدريبية لإدارة الشؤون المالية تمت استضافتها",
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>جمعية سند لدعم الأطفال المرضى بالسرطان</TitleBorderLeft>
    <p className="text-paragraph">سرطان الأطفال بالمملكة وتُقدم مجموعة من الخدمات الاجتماعية وخدمات الإسكان للمحتاجين من المرضى وأسرهم. بالإضافة إلى ذلك، تُقدم الجمعية البرامج التثقيفية والتوعوية للمرضى وأسرهم عن سرطان الأطفال وكيفية التعامل معه.</p>
    <p className="text-paragraph">يتضمن البرنامج كذلك عقد عدد من الفصول الدراسية في المستشفيات تكون مجهزة بمعدات تعليمية متطورة ومعلمين مؤهلين لمساعدة الأطفال المصابين بالسرطان على التأقلم مع أقرانهم أثناء الإقامة بالمستشفى. ينطوي هذا البرنامج التعليمي على مواضيع ومهارات متنوعة للمتعلمين الذين تتراوح أعمارهم بين 3 أعوام و14 عاماً.</p>
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : EducationIcon,
            alt : "",
          },
          spanTwo : "فصل تعليمي في مركز الملك فهد الوطني لأورام الأطفال",
        },{
          number : 317,
          spanTwo : "طالباً"
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>الوعي المالي</TitleBorderLeft>
    <p className="text-paragraph">أطلقنا خلال شهر رمضان سلسلة من جلسات التوعية المنعقدة عبر الإنترنت والموجهة إلى شرائح مختلفة بالمجتمع، وقاد بنك الأول هذه الجلسات بالشراكة مع المركز الوطني للمسؤولية والدراسات. تهدف هذه الحملة إلى زيادة الوعي بشأن الادخار والإنفاق والاستثمار والاحتيال المالي.</p>
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : MonyIncrese,
            alt : ""
          },
          spanTwo : "الوعي المالي في شهر رمضان",
        },{
          number : 40262,
          spanTwo : "مشاركة من الإناث",
        },{
          number : 44202,
          spanTwo : "مشارك من الذكور",
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>برنامج التسريع لذوي الإعاقة</TitleBorderLeft>
    <p className="text-paragraph">تأسس هذا البرنامج بمبادرة من المركز الوطني للمسؤولية والدراسات بالشراكة مع بنك الأول ومنشآت ووزارة الموارد البشرية. وينطوي البرنامج على عدد من الجلسات وورش العمل التدريبية المخصصة للمواطنين من ذوي الإعاقة بهدف تمكينهم من التحول إلى أعضاء منتجين بالمجتمع وامتلاك القدرة على بدء أنشطتهم التجارية الخاصة. وسيحظى خريجو البرنامج بالدعم من الوزارة لبدء العمل على أفكارهم ومشاريعهم وأنشطتهم التجارية.</p>
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : IncreseTwo,
            alt : "",
          },
          spanTwo : "برنامج التسريع لذوي الإعاقة"
        },{
          number : 23093,
          spanTwo : "من الحضور عبر الإنترنت وبشكل شخصي"
        },{
          number : 7,
          spanTwo : "جلسات"
        }
      ]}
    />
    <div className="tabs-image-wrapper">
      <img src={Social1} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">سد الفجوة في المدخرات على المستوى الإقليمي</h2>
    <TitleBorderLeft>برنامج ريالي للوعي المالي</TitleBorderLeft>
    <p className="text-paragraph">
    برنامج ريالي للوعي المالي هو أحد مبادرات بنك الأول لزيادة مستوى الوعي المالي لدى المواطنين السعوديين، وهو البرنامج الاجتماعي الرائد الذي انطلق بالشراكة مع مجموعة سدكو القابضة. يرفع برنامج ريالي مستوى الوعي والتثقيف في المجال المالي عن طريق تزويد المشاركين بالأدوات اللازمة التي تُمكنهم من اتخاذ قرارات مالية سليمة مع اكتساب المهارات اللازمة لإدارة شؤونهم المالية. 
    </p>
    <p className="text-paragraph">
    يقدم هذا البرنامج مجموعة من الدورات التدريبية الخاصة بالمهارات والتثقيف تغطي أساسيات التخطيط المالي والاستثمار والادخار وديناميكيات التضخم، كما يوفر للشباب كذلك التدريب على مبادئ الاقتراض والتمويل وفق الشريعة الإسلامية. تتضمن الوحدات التدريبية للبرنامج الأنماط الاستثمارية وسداد الديون والاقتراض لأغراض الاستثمار. أما على صعيد مهارات ريادة الأعمال، يوفر برنامج ريالي التوجيه اللازم للشركات متناهية الصغر والصغيرة والمتوسطة بشأن التخطيط المالي وتقييم المخاطر.
    </p>
    <p className="text-paragraph">
    استطاع 560 ألفاً من المستفيدين من البرنامج في عام 2019 اكتساب مهارات جديدة من دورات تدريبية قصيرة تضمن نطاقها الأساسيات المالية مثل إعداد الميزانيات والادخار واستيعاب أنماط الاستثمار والتضخم والاقتراض وريادة الأعمال. وقد استطاع هذا البرنامج فائق الشهرة استقطاب أكثر من 90000 شخص في عام 2020 رغم ما شهدته هذه الفترة من إغلاق للمدارس والمؤسسات للحد من انتشار فيروس كورونا. وقد حصل هذا البرنامج على مصادقة من وزارة التعليم للنشر في المدارس. ويتسع نطاق وصول البرنامج يوماً بعد يوم حيث بلغ عدد المستفيدين منه أكثر من 400000 شخص مما ساهم ذلك في رفع الوعي المالي بين أجيال المستقبل بالمملكة. شهد عام 2022 تعاون بنك الأول مع وزارة التعليم لإطلاق مسابقة للوعي المالي للطلاب.
    </p>
    <p className="text-paragraph">
      
    </p>
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : CupIcon,
            alt : "",
          },
          spanTwo : "الجهود الاستثمارية لبرنامج ريالي في تقديم دورات الوعي المالي التدريبية في عام 2022",
        },{
          number : 370000,
          spanTwo : "مشترك في التدريب"
        },{
          number : 370000,
          spanTwo : "طالب مشارك في مسابقة الوعي المالي"
        }
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    
    <TitleBorderLeft>برنامج تقدّم</TitleBorderLeft>
    <p className="text-paragraph">
    يسعى برنامج تقدّم، وهو عبارة عن مسرّعة للأعمال الناشئة قائمة على أنشطة التوجيه، لاستقطاب الجيل القادم من رواد الأعمال على مستوى الشركات متناهية الصغر والصغيرة والمتوسطة بالمملكة. وقد عقدنا شراكة مع جامعة الملك عبدالله للعلوم والتقنية في إطار هذا البرنامج من أجل توفير مسرّعة أعمال لرواد الأعمال حديثي السن عن طريق التنافس. وقد استطاع 150 فريقاً فائزاً على مدار السنوات الأربع الماضية الاستفادة من هذا البرنامج الذي يوفر لرواد الأعمال بالجامعات القدرة على تحويل مشاريعهم إلى نماذج أولية وعلى تجسيد أفكارهم في أنشطة تجارية قائمة. وتستطيع العناصر الواعدة من رواد الأعمال من خلال هذا البرنامج اكتساب المهارات اللازمة للتمكن من التحقق من جدوى أفكار المنتجات أو الخدمات الجديدة وبلورتها في شكل قوالب أو نماذج أولية ثم استقطاب العملاء المحتملين وعرضها على أصحاب المصلحة من المستثمرين.<br /><br />
تحظى أفكار الأعمال التي تتكلل جهود عرضها بالنجاح بالتمويل من بنك الأول، وهو ما يفتح أمام أصحابها الباب كذلك نحو إمكانية الحصول على المزيد من رأس المال. تحصل الفرق الفائزة على منح تمويلية وإمكانية الوصول إلى مساحات عمل مشتركة.
    </p>
    <FlexViewBorder
      items={[
        {
          icon : {
            src : RocketIcon,
            alt : "",
          },
          spanTwo : "تقدّم",
        },
        {
          number: 10,
          spanTwo: "فائزين حصل كل واحد منهم على 375,000 ريال سعودي",
        },
        {
          number: 57,
          spanTwo: "فريقاً مشاركاً",
        },
        {
          number: 112,
          spanTwo: "من الأفراد",
        },
      ]}
    />
    <p className="text-paragraph">
    نجحت مسرعة تقدّم للأعمال على مدار السنوات الأربع الماضية في تخريج 78 شركة ناشئة في قطاعات متنوعة مثل الرعاية الصحية والزراعة والألعاب وخدمات المستهلك والتعليم بإجمالي تمويل 9 ملايين ريال سعودي، وقد نجحت العديد من هذه الشركات الناشئة في بلوغ التصفيات النهائية في المسابقات العالمية للتقنيات وريادة الأعمال.
    </p>
    <p className="text-paragraph">
    يوفر البرنامج كذلك للمشاركين الدعم غير المالي، حيث يوفر للشركات متناهية الصغر والصغيرة والمتوسطة التوجيه اللازم بالإضافة إلى المزيد من فرص التدريب على يد فريق متميز من المدربين والاستشاريين المحليين والدوليين. ومن المتوقع أن يستقطب الفوج الخامس للبرنامج، المقرر أن يكون في عام 2023، 60 فريقاً من جميع أرجاء المملكة، وسيتقاسم الفوج الجيد من فرق ريادة الأعمال الفائزة الجوائز المالية التي ستبلغ حوالي 6 ملايين ريال سعودي.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social2} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">تطوير الممارسات البيئية والاجتماعية والحوكمة المؤسسية والسوق المالي المستدام</h2>
    <BorderLeftBox
      title="جهود الدعم"
      subtitle="بفضل مكانة بنك الأول في السوق وخبرته الدولية النابعة من شراكته مع إتش إس بي سي، فإنه يمتلك القدرة على المساعدة في قيادة الجهود في مجال الحوكمة البيئية والاجتماعية والمؤسسية بالقطاع المالي بالمملكة. وإننا لنفخر أشد الفخر بالعلاقات الوثيقة التي تربطنا بمختلف الجهات التنظيمية، والتي بفضلها نتمكن من المشاركة مع تلك الجهات ومع غيرها من الجهات الفاعلة بالسوق لتعزيز جهودنا الداعمة لجدول أعمال الحوكمة البيئية والاجتماعية والمؤسسية في جميع أنحاء المملكة العربية السعودية في ضوء مسيرتنا نحو تحقيق رؤية 2030."
    />
    <p className="text-paragraph">
    وفي إطار دعم بنك الأول لقضية الحوكمة البيئية والاجتماعية والمؤسسية ، فقد شارك في عدد من منتديات الاستدامة والمبادرات القطاعية البارزة في هذا العام. ومن بين أهم تلك الفعاليات منتدى مبادرة السعودية الخضراء الذي جاء ضمن مؤتمر الأمم المتحدة المعني بتغير المناخ (COP27) في شرم الشيخ، مصر، حيث سلط هذا الحدث الضوء على المكانة الرائدة التي تنشدها المملكة في قضية تغير المناخ. تولى البنك كذلك رعاية المنتدى البريطاني السعودي للطاقة المتجددة الذي نظمه مجلس الأعمال السعودي البريطاني المشترك (SBJBC)، وهي الفعالية التي انعقدت في لندن وحضرها لفيف من الوزراء وكبار المسؤولين الحكوميين والمستثمرين من المملكة المتحدة والمملكة العربية السعودية في جولة من المحادثات التفاعلية التي تمحور النقاش بها حول فرص الاستثمار في الطاقة النظيفة بالمملكة المتحدة والمملكة العربية السعودية.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social3} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">التحول الرقمي</h2>
    <BorderLeftBox
      title="رحلة بنك الأول في المجال الرقمي"
      subtitle="في إطار تحقيق بنك الأول لأهدافه الاستراتيجية، ضاعف البنك حجم الاستثمار الذي يضخه في مشاريع التحول الرقمي ثلاث مرات، وهي أولوية متأصلة لدى البنك. ستُثمر هذه الجهود عن تحقيق حجم هائل من التوفير في التكلفة التي سيمكن تجنبها بفضل التحول الرقمي على مدار السنوات الخمس المقبلة مما سيتبلور في شكل تحسين لهوامش الأرباح. علاوة على ذلك، فسيُمكن للبنك من خلال التحول الرقمي تقديم خدمة أفضل للعملاء من خلال تمكينهم من إجراء المعاملات المصرفية من أي مكان وفي أي وقت من خلال مجموعة متنوعة من الأدوات المبتكرة الرقمية التي ستجعل من بنك الأول جهة أكثر مناسبة للعملاء وستمنحه قدرة تنافسية أعلى، أضف إلى ذلك أنه سيوفر لشرائح العملاء غير المتعاملين مع البنوك أو الذين لا يستطيعون الوصول إلى الخدمات البنكية قدرة أكبر على الوصول إلى الخدمات البنكية واستخدامها. ولمزيد من المعلومات بشأن استراتيجيتنا الرقمية وأنشطتنا الاستثمارية في المنتجات الرقمية، يرجى الرجوع إلى الصفحة 40 من تقريرنا السنوي."
    />
    <p className="text-paragraph">
    يعمل التحول الرقمي كذلك على رفع مستوى القدرة على الحصول على التمويل، وهو ما شجع بنك الأول على صب تركيز كبير على خدمة قطاع الشركات الصغيرة لديه في عام 2022: 
      <ul>
        <li>
        أطلقنا بنجاح تطبيقنا المصرفي "ساب كورب" للهواتف المتحركة الذي يتضمن دعم خدمة "سريع" للمدفوعات الفورية على مدار الساعة. ويُمكن للشركات متناهية الصغر والصغيرة والمتوسطة كذلك استخدام التطبيق لاعتماد دفع الرواتب وإنشاء كلمات المرور والتعامل مع كشوف الحسابات في الوقت الفعلي. وقد شهد التطبيق تنفيذ أكثر من 14000 عملية دفع من خلاله حتى الآن.
        </li>
        <li>
        يُقدم بنك الأول لعملائه إمكانية جديدة لفتح الحسابات بشكل رقمي تُثمر عن تقليص المدة الزمنية اللازمة لتسجيل العملاء من الشركات متناهية الصغر والصغيرة والمتوسطة والمؤسسات على حد سواء من أسبوعين إلى يومين فقط تقريباً.
        </li>
        <li>
        تولينا كذلك دمج منصة "منشآت" مع نظامنا الخاص لإدارة علاقات العملاء، مما يوفر لعملائنا من الشركات متناهية الصغر والصغيرة والمتوسطة قدرة أكبر على الوصول إلى التمويل فضلاً عن إمكانية إجراء المعاملات بشكل أسهل.
        </li>
        <li>
        يحمل بنك الأول على عاتقه الالتزام بمواصلة تحسين إمكانية الوصول إلى التمويل من خلال التوسع في قدراته الرقمية.
        </li>
      </ul>
    </p>
    <Separator />
    <TitleBorderLeft>أكاديمية الأول الرقمية</TitleBorderLeft>
    <p className="text-paragraph">
    تُقدم أكاديمية الأول الرقمية المساعدة للمشاركين على اكتساب المهارات التي تعزز من فرص التوظيف في القطاع المالي. تأسست الأكاديمية في عام 2017 وتستعين بأحدث الحلول الرقمية المبتكرة في تقديم دورات تدريبية متقدمة مجانية في قطاع الخدمات المصرفية للأفراد، والاستشارات الائتمانية، بالإضافة إلى المهارات الشخصية الأخرى. ويتمثل شريكا البنك في هذا البرنامج في كل من شركة تكامل لخدمات الأعمال والأكاديمية المالية، وهي إحدى مبادرات برنامج تطوير القطاع المالي التي تدعم تحقيق رؤية 2030. 
وتماشياً مع مستهدفات رؤية السعودية 2030 فيما يتعلق بخفض معدل البطالة، يستهدف هذا البرنامج كذلك إحداث تأثير إيجابي في عملية تحسين معدل دخول غير الموظفين إلى سوق العمل، هذا فضلاً عن دعمه للموظفين الحاليين في اكتساب المهارات الجديدة. يُعد تمكين المتدربين الناجحين من المشاركة في معارض الوظائف جزءاً لا يتجزأ من هدف البرنامج المتمثل في توفير الوظائف لدى مجموعة متنوعة من جهات العمل. وقد أبدت العناصر المستقطبة للأكاديمية وكذلك المسؤولون عن استقطاب تلك العناصر تعليقات إيجابية للغاية.
    </p>
    <FlexViewBorder
      items={[
        {
          icon : {
            src : Academy,
            alt : "",
          },
          spanTwo : "الجهود الاستثمارية لأكاديمية الأول الرقمية في تقديم دورات الوعي المالي التدريبية في عام 2022"
        },
        {
          number: 1200,
          spanTwo: "متدرب في عام 2022",
        },
        {
          spanOne: "أكثر من ",
          title : "135",
          spanTwo: "دورة تدريبية متوفرة",
        },
      ]}
    />
    <p className="text-paragraph">
    تُثمر جهود التعاون بين بنك الأول والأكاديمية المالية عن توفير مزيد من الدورات بشكل رقمي. وقد عملت الأكاديمية منذ تأسيسها على تأهيل أكثر من 600 متدرب ومتدربة لدخول سوق العمل. وتتضمن موضوعات التدريب المتاحة موضوعات متعلقة بمكافحة الاحتيال وغسل الأموال، ودورات اللغة الإنجليزية، وغير ذلك من مهارات أماكن العمل. وسيُسمح من الآن فصاعداً لأفضل 400 متدرب ومتدربة الخضوع لاختبار الأكاديمية المالية.
    </p>
    <div className="space-50"></div>
    <Separator />
    <TitleBorderLeft>الأمن السيبراني</TitleBorderLeft>
    <h4 className="text-title-gray-background">لمحة عامة</h4>
    <p className="text-paragraph">
    من المكونات الرئيسية لإطار عملنا في إدارة المخاطر بالبنك، يستثمر البنك في التخفيف من التطور السريع في مجال التهديدات السيبرانية ، والتي تظل مصدر قلق للمؤسسة، كما هو الحال في القطاع المالي. قد يؤدي الفشل في حماية عملياتنا إلى تعطيل لعملائنا، أو التلاعب بالبيانات، أوالخسارة المالية، و هذا يمكن أن يكون لها تأثير سلبي على عملائنا و سمعة البنك. وانطلاقاً من ذلك، يسعى البنك باستمرار لتعزيز إطار عمل المراقبة السيبرانية بهدف تحسين المرونة في مجال تقنية المعلومات وتعزيز قدرات الأمن السيبراني. وتتضمن مجالات التركيز الرئيسية الكشف عن التهديدات وتحليلها، والتحكم في الوصول، وضوابط أنظمة الدفع، وحماية البيانات، وضوابط الشبكات، والنسخ الاحتياطي واسترداد البيانات.
    </p>
    <p className="text-paragraph">
    يبدأ الإشراف لدى بنك الأول على أمن المعلومات والمخاطر السيبرانية من مستوى الإدارة العليا ومجلس الإدارة من أجل ضمان تحقيق المستوى المناسب من التدقيق والدعم التنفيذي لبرنامجنا المتواصل للأمن السيبراني. ويمتلك جميع من في البنك بغض النظر عن مستوياتهم على نظرة شاملة وكاملة عن مستوى المؤسسة لمخاطر تقنية المعلومات والحوكمة.
    </p>
    <p className="text-paragraph">
    وتتضمن أنشطة الحوكمة بالبنك مراجعة ومراقبة إطار عمل أمن المعلومات والحوكمة السيبرانية بالإضافة إلى إدارة مخاطر أمن المعلومات والأمن السيبراني وحماية الخصوصية. وتخضع جميع المخاطر الناشئة عن ملف المخاطر السيبرانية لدى البنك للمراقبة ومن ثم تُتخذ التدابير التصحيحية لاحتواء هذه المخاطر.
    </p>
    <p className="text-paragraph">
    وينصب تركيز بنك الأول كذلك على مواصلة الامتثال لأطر العمل والمبادرات التنظيمية الصادرة من البنك المركزي السعودي والهيئة الوطنية للأمن السيبراني. وتتكلل الجهود المبذولة للامتثال بنجاح مشهود، حيث حقق بنك الأول مستوى امتثال بنسبة 100% للمستويين 3 و4 من مستويات النضج المطبقة لدى البنك المركزي السعودي. تم التحقق من صحة التصنيف من جانب إدارة المراجعة الداخلية وكذلك من جانب جهة مستقلة مرموقة.
    </p>
    <p className="text-paragraph">
    يُعد هذا الإنجاز إضافة إلى النجاحات السابقة المحققة في برنامجنا الفعال لإدارة مخاطر الأمن السيبراني. وفقاً لتقييم أجرته الجهات التنظيمية بشأن ضوابط الأمن السيبراني الأساسية الصادرة عن الهيئة الوطنية للأمن السيبراني في عام 2021، استطاع بنك الأول تحقيق مستوى عالٍ من الامتثال على مستوى جميع الضوابط المناسبة.
    </p>
    <p className="text-paragraph">
    ستتولى إدارة المراجعة الداخلية ببنك الأول مراقبة أمن المعلومات من الآن فصاعداً بصورة منتظمة بالتنسيق مع مراجعين خارجيين مستقلين. وقد اكتملت آخر عملية مراجعة في الربع الأول من عام 2023.
    </p>
    <h4 className="text-title-gray-background">
    استراتيجية وسياسات مخاطر أمن المعلومات
    </h4>
    <p className="text-paragraph">
      يمتلك بنك الأول استراتيجية لمخاطر أمن المعلومات يستهدف بها الحفاظ على أعلى معايير الأمن السيبراني، وهي الاستراتيجية التي تتوافق مع المتطلبات التنظيمية وتتناسب مع التقنيات الجديدة وتهديدات الأمن السيبراني الناشئة. وتدعم هذه الاستراتيجية سياسة لمخاطر أمن المعلومات تتضمن تقييم مستوى الأمان وإدارة الهوية والوصول والاعتبارات الخاصة بمخاطر أمن المعلومات.
      <br /><br /> 
      ويمتلك البنك مجموعة شاملة من السياسات والنظم الخاصة بالأمن السيبراني المصممة للمساعدة في ضمان الإدارة الجيدة للمؤسسة مع تحقيق الإشراف والرقابة.
      <br /><br />
      كما يحرص البنك برفع تقارير بشأن المخاطر السيبرانية ومستوى فعالية المراقبة على مستويات الحوكمة والجهات الأخرى ذات الصلة ومراجعتها بشكل منتظم.
    </p>
    <h4 className="text-title-gray-background">
      الوقاية من المخاطر والكشف عنها وتخفيفها
    </h4>
    <p className="text-paragraph">
      في إطار إدارة مخاطر أمن المعلومات، يدشن البنك العديد من المبادرات المختلفة لتحسين وضع الأمن السيبراني. علاوة على ذلك، يعكف البنك على مراقبة مستوى امتثاله لمبادئ تحليل التهديدات السيبرانية للقطاع المالي الصادرة عن البنك المركزي السعودي لضمان تنفيذها في الوقت المناسب. أضف إلى ذلك تمتع البنك بالقدرة على تحليل التهديدات والمعلومات في المجال السيبراني، حيث نعمل على جمع البيانات السيبرانية الخارجية وتحليلها بشكل استباقي. علاوة على ذلك، يُنفذ بنك الأول كذلك برامج إدارة الثغرات (VM) واختبار الاختراق (PT)، وهي الاختبارات التي تستهدف البحث عن الثغرات الأمنية في جميع الأصول التي يتم التعامل معها على المستوى الداخلي والخارجي لضمان الكشف عن مخاطر أمن المعلومات الناشئة ومعالجتها في الوقت المناسب. تخضع أصول البنك التي تواجه الجمهور لاختبارات أكثر صرامة نظراً لكونها أكثر عرضة للهجمات الخارجية مقارنة بالأصول الداخلية - ويتمثل هدفنا في القضاء على جميع الثغرات في الأصول الخارجية.
    </p>
    <p className="text-paragraph">
      شهد عام 2022 تعزيزنا لآليات الدفاع السيبرانية بالبنك ولقدراتنا في مجال الأمن السيبراني بهدف المساعدة على خفض احتمالية وقوع حالات الوصول غير المصرح به واستغلال الثغرات الأمنية وتسرب البيانات والتعرض للمخاطر الأمنية الخاصة بالجهات الخارجية والبرامج الضارة المتطورة وتقليل ما يستتبع ذلك من آثار. وتعتمد آليات الدفاع هذه على نهج تحليلي استباقي للبيانات يُساعد على تحديد التهديدات المستهدفة المتطورة.
    </p>
    <p className="text-paragraph">
      تعمل آلية التحكم في إدارة الوصول لدى بنك الأول على ضمان حماية أصول المعلومات من المستخدمين غير المصرح لهم. علاوة على ذلك، يتولى فريق إدارة الوصول لدينا مراجعة التحكم في الوصول (إعادة اعتماد الوصول) لأنظمة البنك ومستخدميه لضمان الامتثال لسياسات التحكم في إدارة الوصول. وعلى صعيد آخر، يُمثل دليل التعليمات الوظيفية لمخاطر أمن المعلومات الداخلي لدى بنك الأول سياسة شاملة لحماية جميع أشكال المعلومات وأنظمتها من عمليات الوصول والاستخدام والإفصاح والتعطل والتعديل والإتلاف غير المصرح بها. ويتمثل الهدف من ذلك في ضمان سرية المعلومات وسلامتها وتوافرها مع العمل في الوقت ذاته على تشديد الضوابط الأمنية لمواجهة التهديدات السيبرانية. يمتلك البنك كذلك سياسة للوقاية من فقدان البيانات يستهدف بها مراقبة حركة معلومات بالبنك والتحكم فيها بالإضافة إلى تطبيق الإجراءات التصحيحية اللازمة للتخفيف من أثر أي اختراق لأمن البيانات.
    </p>
    <p className="text-paragraph">
      لم يتعرض بنك الأول لأي خروقات سيبرانية على مدار السنوات الثلاث الماضية. ومما يدل ذلك على الضوابط القوية التي يمتلكها البنك لحماية أمن المعلومات، فقد حصل بنك الأول على شهادة التوافق مع المعايير الأمنية لبطاقات المدفوعات (PCI DSS) في عام 2022م، وهي الشهادة التي يقرها البنك المركزي السعودي وتكون صالحة لمدة عام واحد مع وجود تجديدها سنوياً. تبلغ كذلك نسبة امتثال بنك الأول لضوابط الأمن السيبراني الأساسية الصادرة عن الهيئة الوطنية للأمن السيبراني 97% وفقاً للتقييم الذي أجرته الجهات التنظيمية، وقد جرى اتخاذ التدابير اللازمة لرفع النسبة إلى 100%.
    </p>
    <h4 className="text-title-gray-background">
      التوعية والتدريب بمجال الأمن السيبراني
    </h4>
    <p className="text-paragraph">
      نعي جيداً أهمية الدور الذي يضطلع به الموظفون لدينا في الحماية من تهديدات الأمن السيبراني، ولذا أقام بنك الأول برنامجاً للتوعية في مجال الأمن السيبراني استهدف به تعزيز الوعي بهذا المجال بين موظفي البنك وعملائه مستعيناً في ذلك بمنصات مختلفة لمشاركة المعلومات عن الحملة تتضمن استخدام الشبكة الداخلية (الإنترانت) وشاشات التوقف وعمليات نشر البريد الإلكتروني والندوات عبر الإنترنت. علاوة على ذلك، فقد استضاف البنك شهر التوعية بالأمن السيبراني لجميع موظفي بنك الأول وأعضاء مجلس الإدارة به في شهر أكتوبر بالاستعانة بقنوات متعددة لتغطية مختلف موضوعات الأمن السيبراني.
    </p>
    <p className="text-paragraph">
      كما يعقد البنك كذلك دورتين تدريبيتين إلزاميتين لأمن السيبراني لجميع الموظفين كل عام. شهد عام 2022 استكمال 98.43% من الموظفين للتدريب على الوعي بأمان البريد الإلكتروني واستكمال 97.21% منهم التدريب على حماية معلومات بنك الأول. كما تلقى فريق الأمن السيبراني خلال فترة المراجعة مجموعة من التدريبات متخصصة في مجال الأمن السيبراني.
    </p>
    <p className="text-paragraph">
      يضطلع عملاء البنك هم أيضاً بدور في حماية خصوصيتهم، ومن ثم يعكف بنك الأول على تعزيز مستوى الوعي بتهديدات الأمن السيبراني بين عملائه باستخدام منصات رقمية خارجية مثل الموقع الإلكتروني وغير ذلك من المنصات عبر الإنترنت بهدف تثقيفهم ورفع مستوى المعرفة لديهم.
    </p>
    <div className="tabs-image-wrapper">
      <img src={Social4} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">المبادرات المجتمعية</h2>
    <p className="text-paragraph">يُسهم بنك الأول في مجموعة متنوعة من برامج الارتقاء الاجتماعي للمواطنين السعوديين. وحتى نتمكن من توسيع نطاق وصولنا على الصعيد الاجتماعي، يعقد البنك شراكات مع مختلف المؤسسات، بما في ذلك المؤسسات الخيرية والوكالات الحكومية والمنظمات غير الهادفة للربح، وهي الشراكات التي تُثمر عن تحقيق نتائج ذات تأثير أكبر مقارنة بما لو كانت هذه النتائج محققة بجهود بنك الأول وحده فقط.</p>
    <TitleBorderLeft>بنك الطعام السعودي</TitleBorderLeft>
    <p className="text-paragraph">
      بينما يتعامل المجتمع المعاصر مع الطعام على أنه سلعة مملوكة ملكية خاصة، يُمكن أن ينطوي الطعام على مصلحة عامة مشتركة عند وضع مفهوم جديد لمنظومة الطعام المستدام في إطار إقامة مجتمع مستدام، حيث تُمكن مشاركة الطعام بدلاً من التخلص منه في القمامة. ويسعى بنك الأول لتعزيز عملية مشاركة الطعام تضامناً مع الفئات المحرومة بالمجتمع. 
      <br /><br />
      شهد عام 2022 إنشاء البنك، بالتعاون مع منظمة إطعام غير الحكومية الرائدة العاملة في مجال حفظ الأغذية، لأول بنك غذائي لحفظ الأطعمة الجافة في البلاد. تحتضن مدينة الرياض مطبخاً مركزياً مجهزاً بالتقنيات الأساسية للحفاظ على الطعام الجاف الفائض، والذي يعمل على توفير الوجبات بانتظام للأسر المستفيدة من الضمان الاجتماعي والأشخاص ذوي الإعاقة والأيتام.
    </p>
    <p className="text-paragraph">
      يُقدم بنك الأول المساهمة المالية للبرنامج التي تُغطي تكاليف إقامة المشروع وتشغيله والخدمات اللوجستية اللازمة له، بينما تتولى مؤسسة إطعام تنفيذ المشروع وإدارته. علاوة على ذلك، سنطوي البرنامج أيضاً على بناء شراكات طويلة الأمد مع شركات الأغذية التي تؤمن بقيمة الحفاظ على الأطعمة الجافة وتحويلها إلى وجبات جاهزة للأكل. ويتمثل هدفنا الطموح في توفير أكثر من 500000 طن من الأطعمة الجافة والمعلبة بما يُساهم بقوة في ضمان الأمن الغذائي.
    </p>
    <FlexViewBorder
      items={[
        {
          icon : {
            src : HandLeave,
            alt : "",
          },
          spanTwo : "الجهود الاستثمارية لبنك الطعام السعودي في حفظ الأطعمة الجافة في عام 2022",
        },
        {
          number: 400000,
          spanTwo: "وجبة مقدمة",
        },
        {
          number: 500000,
          spanTwo: "طن من الأطعمة تم حفظه",
        },
      ]}
    />
    <p className="text-paragraph">
      من المبادرات الأخرى التي أطلقتها مؤسسة إطعام، مبادرة إعادة تغليف وتوزيع 100000 وجبة على 6000 أسرة مسجلة محتاجة خلال موسم الرياض الذي امتد لستة أشهر. 
      <br /><br />
      وقد قمنا حتى الآن بتوزيع 11,231 وجبة و70 سلة طعام تحتوي على منتجات جافة ومعلبة على الأسر المحتاجة في مدينة الرياض . تتوسع جهود المشروع انطلاقاً من الشراكة الاستراتيجية بين بنك الأول ومؤسسة إطعام؛ وهي الشراكة التي سيواصل البنك في إطارها دعم مبادرات بنك إطعام ومشاريعه في مجال حفظ الطعام بالإضافة إلى توفير الدعم للشراكات وزيادة مستوى الوعي بين المنظمات المجتمعية وترسيخ مفهوم التضامن الاجتماعي.
    </p>
    
    <FlexViewBorder 
      items={[
        {
          icon : {
            src : Recycle,
            alt : "",
          },
          spanTwo : "الجهود الاستثمارية لبنك الطعام السعودي في حفظ الوجبات الجاهزة وتوزيع في عام 2022",
        },{
          number : 100000,
          spanTwo : "وجبة",
        },
        {
          number : 70,
          spanTwo : "سلة طعام",
        },
        {
          number : 120,
          spanTwo : "طناً من الأطعمة",
        }
      ]}
    />
    <p className="text-paragraph">
      إضافةً إلى ما سبق، يدرك بنك الأول أن فعل الخير والإحسان للآخرين هو من فضائل الأعمال الروحانية، وخاصة في شهر رمضان الكريم. وخلال شهر رمضان السابق، تعاون البنك مع 12 جمعية خيرية للوصول إلى الأسر ذات الدخل المنخفض من خلال مبادرة سلة الأول الرمضانية.
    </p>
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <TitleBorderLeft>برنامج ترميم</TitleBorderLeft>
    <p className="text-paragraph">
      يُعد الحق في الحصول على المأوى من الحقوق المعترف بها عالمياً - حيث يُمثل توفير السكن الآمن أحد ضروريات تحقيق الرفاه للجميع. وانطلاقاً من هذا المفهوم، يدعم برنامج ترميم بناء المنازل وتجديدها للعائلات المحتاجة. تعتمد هذه المبادرة على العمل الميداني الذي يضطلع به كل من البنك والفرق المتخصصة في البحث عن العائلات التي تحتاج إلى المساعدة.
    </p>
    <FlexViewBorder
      items={[
        {
          icon : {
            src : SocialIcon2,
            alt : "",
          },
          spanTwo : "الدفعة النهائية لبرنامج ترميم في عام 2022"
        },
        {
          spanOne : "تم ترميم",
          number: 18,
          spanTwo: "منزلاً",
        },
      ]}
    />
    <div className="tabs-image-wrapper">
      <img src={Social5} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
  <>
    <h2 className="text-title">مواردنا البشرية: حجر الأساس لنجاح البنك</h2>
    <p className="text-paragraph">يفخر بنك الأول بفريقه الذي يتميز بمستوى عالٍ من الجودة ويؤمن بأنهم عماد نجاحه ولولاهم لما أمكن تنفيذ أي استراتيجية للحوكمة البيئية والاجتماعية والمؤسسية تستهدف تعزيز رفاه المجتمع والكوكب ككل. كما يرعى البنك موارده البشرية، وهو ما يتضح من استطلاع الموظفين السنوي الذي شهد نسبة إدماج للموظفين بلغت 73% والذي أفاد بأن الأوضاع قد تحسنت بنسبة 15% مقارنة بعام 2021.</p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary">
      <thead>
        <tr></tr>
        <tr>
          <th>إحصاءات مواردنا البشرية</th>
          <th className="">2020</th>
          <th className="">2021</th>
          <th className="">2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>إجمالي عدد العاملين (باستثناء المتدربين والطلاب والموظفين بعقود خارجية)</td>
          <td className="">4,054</td>
          <td className="">3,705</td>
          <td className="bg-light-red ">3,709</td>
        </tr>
        <tr>
          <td>الموظفون بعقود غير محددة المدة أو دائمة</td>
          <td className="">4,054 </td>
          <td className="">3,705 </td>
          <td className="bg-light-red ">3,709</td>
        </tr>
        <tr>
          <td>الموظفون لأجل محدد أو بعقود مؤقتة</td>
          <td className="">2,072</td>
          <td className="">1,932</td>
          <td className="bg-light-red ">2,019</td>
        </tr>
        <tr>
          <td>موظفو الإدارة العليا</td>
          <td className="">142</td>
          <td className="">140</td>
          <td className="bg-light-red ">169</td>
        </tr>
        <tr>
          <td>موظفو الإدارة المتوسطة</td>
          <td className="">1,312</td>
          <td className="">1,229</td>
          <td className="bg-light-red ">1,332</td>
        </tr>
        <tr>
          <td>الموظفون من غير الإدارة</td>
          <td className="">2,600</td>
          <td className="">2,317</td>
          <td className="bg-light-red ">2,208</td>
        </tr>
        <tr>
          <td>المتدربون والطلاب الخاضعون للرعاية</td>
          <td className="">75</td>
          <td className="">109</td>
          <td className="bg-light-red ">97</td>
        </tr>
        <tr>
          <td>مديرو الفروع</td>
          <td className="">117</td>
          <td className="">105</td>
          <td className="bg-light-red ">100</td>
        </tr>
        <tr>
          <td>عدد الجنسيات الممثلة</td>
          <td className="">33</td>
          <td className="">28</td>
          <td className="bg-light-red ">29</td>
        </tr>
      </tbody>
    </table>
    </div>
    <h4 className="text-title-gray-background">التوظيف ومعدل دوران الموظفين</h4>
    <p className="text-paragraph">
      يُمثل معدل دوران الموظفين أحد المؤشرات المهمة على مستوى إدماج الموظفين ونمو الأعمال. وقد شهدت أعداد الموظفين لدى بنك الأول نمواً مطرداً على مدار السنوات القليلة الماضية. وفي الوقت الذي أسفرت فيه جائحة فيروس كورونا عن زيادة في معدل دوران الموظفين في عام 2021، فقد انعكس هذا الاتجاه على نفسه وانخفض معدل الدوران.
    </p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <tr>
        <th>الموظفون الجدد ومعدل دوران الموظفين</th>
        <th>2020</th>
        <th>2021</th>
        <th>2022</th>
      </tr>
      <tr>
        <th>إجمالي عدد الموظفين الجدد:</th>
        <th>35</th>
        <th>342</th>
        <th>440</th>
      </tr>
      <tr>
        <td>إجمالي عدد الموظفين الجدد بحسب السن:</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>السن 18-30</td>
        <td>4</td>
        <td>160</td>
        <td>239</td>
      </tr>
      <tr>
        <td>السن 31-50</td>
        <td>29</td>
        <td>175</td>
        <td>198</td>
      </tr>
      <tr>
        <td>السن أكبر من 51</td>
        <td>2</td>
        <td>7</td>
        <td>3</td>
      </tr>
      <tr>
        <th>إجمالي عدد الموظفين الجدد بحسب النوع:</th>
        <th aria-hidden="true"></th>
        <th aria-hidden="true"></th>
        <th aria-hidden="true"></th>
      </tr>
      <tr>
        <td> الذكور</td>
        <td>30</td>
        <td>223</td>
        <td>277</td>
      </tr>
      <tr>
        <td> الإناث</td>
        <td>5</td>
        <td>119</td>
        <td>163</td>
      </tr>
      <tr>
        <th>معدل دوران الموظفين (الطوعي وغير الطوعي)</th>
        <th>411</th>
        <th>652</th>
        <th>464</th>
      </tr>
      <tr>
        <td>السن 18-30</td>
        <td>70</td>
        <td>65</td>
        <td>86</td>
      </tr>
      <tr>
        <td>السن 31-50</td>
        <td>288</td>
        <td>400</td>
        <td>319</td>
      </tr>
      <tr>
        <td>السن أكبر من 51</td>
        <td>53</td>
        <td>187</td>
        <td>59</td>
      </tr>
      <tr>
        <td>الذكور</td>
        <td>307</td>
        <td>512</td>
        <td>346</td>
      </tr>
      <tr>
        <td>الإناث</td>
        <td>104</td>
        <td>140</td>
        <td>118</td>
      </tr>
      <tr>
        <td>الإدارة العليا</td>
        <td>27</td>
        <td>40</td>
        <td>21</td>
      </tr>
      <tr>
        <td>موظفو الإدارة المتوسطة</td>
        <td>176</td>
        <td>303</td>
        <td>203</td>
      </tr>
      <tr>
        <td>الموظفون من غير الإدارة</td>
        <td>208</td>
        <td>309</td>
        <td>240</td>
      </tr>
      <tr>
        <td>العاملون بالعقود</td>
        <td>127</td>
        <td>195</td>
        <td>289</td>
      </tr>
      <tr>
        <th className="border-bottom-none">معدل دوران الموظفين (الطوعي وغير الطوعي) (نسبة مئوية)</th>
        <th className="border-bottom-none">%10</th>
        <th className="border-bottom-none">%17</th>
        <th className="border-bottom-none">%12.6</th>
      </tr>
      <tr>
        <th>معدل دوران الموظفين (الطوعي)</th>
        <th>354</th>
        <th>419</th>
        <th>334</th>
      </tr>
      <tr>
        <td>السن 18-30</td>
        <td>64</td>
        <td>64</td>
        <td>79</td>
      </tr>
      <tr>
        <td>السن 31-50</td>
        <td>263</td>
        <td>333</td>
        <td>249</td>
      </tr>
      <tr>
        <td>السن أكبر من 51</td>
        <td>27</td>
        <td>22</td>
        <td>6</td>
      </tr>
      <tr>
        <td>الذكور</td>
        <td>251</td>
        <td>295</td>
        <td>227</td>
      </tr>
      <tr>
        <td> الإناث</td>
        <td>18</td>
        <td>20</td>
        <td>107</td>
      </tr>
      <tr>
        <td>الإدارة العليا</td>
        <td>157</td>
        <td>197</td>
        <td>13</td>
      </tr>
      <tr>
        <td>موظفو الإدارة المتوسطة</td>
        <td>173</td>
        <td>194</td>
        <td>152</td>
      </tr>
      <tr>
        <td>الموظفون من غير الإدارة</td>
        <td>18</td>
        <td>20</td>
        <td>169</td>
      </tr>
      <tr>
        <td>العاملون بالعقود</td>
        <td>101</td>
        <td>63</td>
        <td>136</td>
      </tr>
      <tr>
        <th>معدل دوران الموظفين (الطوعي) (نسبة مئوية)</th>
        <th>%9</th>
        <th>%11.6</th>
        <th>%9</th>
      </tr>
    </table>
    </div>
    <p className="text-paragraph">يسعدنا أن نعلن عن أن بنك الأول هو صاحب أقل معدل لدوران الموظفين في عام 2022 بحسب استطلاع الخدمات المصرفية الذي أجراه "الملتقى" (ملتقى الموارد البشرية للبنوك السعودية) مقارنة بالبنوك السعودية التالية:</p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <thead>
        <tr></tr>
        <tr>
          <th aria-hidden="true"></th>
          <th>بنك الخليج الدولي</th>
          <th>بنك البلاد</th>
          <th>البنك العربي الوطني</th>
          <th>بنك الرياض</th>
          <th>مصرف الإنماء</th>
          <th>البنك السعودي الفرنسي</th>
          <th>بنك الأول</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>إجمالي معدل دوران الموظفين</td>
          <td>%12.9</td>
          <td>%15.1</td>
          <td>%13.3</td>
          <td>%13.2</td>
          <td>%13.41</td>
          <td>%13.9</td>
          <td>%12.6</td>
        </tr>
        <tr>
          <td>معدل دوران الموظفين المأسوف عليهم</td>
          <td>%9.7</td>
          <td>%12.0</td>
          <td>%8.7</td>
          <td>%9.9</td>
          <td>%7.9</td>
          <td>%12.1</td>
          <td>%7.3</td>
        </tr>
      </tbody>
    </table>
    </div>
    <Separator />
    <h4 className="text-title-gray-background">التوطين</h4>
    <p className="text-paragraph">
      يعد خفض عدد المواطنين السعوديين غير العاملين ركناً ركيناً في رؤية 2030. وإنه لمن دواعي فخر بنك الأول أن تبلغ نسبة المواطنين السعوديين 90% من بين إجمالي عدد موظفيه. غير أننا نعي جيداً أهمية التنوع ونحظى بالفعل بمجموعة من المهارات والخبرات المتنوعة التي تمتلكها العناصر البشرية التي تنحدر من 29 دولة مختلفة بين صفوفنا.
      <br /> 
      وفي إطار جهودنا المبذولة لدعم توظيف العناصر السعودية والاحتفاظ بها، يدعم بنك الأول برامج الدراسات العليا للمواطنين السعوديين كما يتولى إقامة برامج التطوير للموظفين الحاليين.
    </p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <thead>
        <tr></tr>
        <tr>
          <th>التوطين</th>
          <th>2020</th>
          <th>2021</th>
          <th>2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>السعودة بالإدارة العليا (نسبة مئوية)</td>
          <td>%65</td>
          <td>%66</td>
          <td className="bg-light-red">%66</td>
        </tr>
        <tr>
          <td>التوطين بين إجمالي القوى العاملة (نسبة مئوية)</td>
          <td>%90.6</td>
          <td>%90.6</td>
          <td className="bg-light-red">%90.1</td>
        </tr>
        <tr>
          <td>إجمالي عدد الموظفين من المواطنين</td>
          <td>3,674</td>
          <td>3,358</td>
          <td className="bg-light-red">3,341</td>
        </tr>
        <tr>
          <td>عدد الموظفات المواطنات</td>
          <td>799</td>
          <td>781</td>
          <td className="bg-light-red">825</td>
        </tr>
      </tbody>
    </table>
    </div>
    <p className="text-paragraph">
      احتفل بنك الأول في عام 2022 بتخريج 19 متدرباً من برنامج الأول للخريجين، وهو ما تبعه انضمام جميع المرشحين إلى الشركة للعمل بدوام كامل. كما أطلقنا كذلك برنامج "ساب تك للخريجين"، وهو البرنامج الموجه لخريجي مجالات التقنية ويشارك فيه في الوقت الحالي 24 خريجاً. كما شهد عام 2023 إطلاقنا كذلك لبرنامج الأول للخريجين لمصرفية الشركات، والذي يستقبل البنك من خلاله 20 خريجاً بخلفية مالية.
    </p>
    <Separator />
    <h4 className="text-title-gray-background">
      دعم إقامة ثقافة من الرفاه والإدماج للموظفين
    </h4>
    <p className="text-paragraph">
      يرى بنك الأول أنه من المهم أن يشعر موظفوه بالتحفيز والدمج. ولذا يُسعده الإعلان عن الارتفاع في مستوى إدماج الموظفين لديه بحسب استطلاع الموظفين المجرى في عام 2022، والذي شارك فيه 99% من إجمالي عدد الموظفين بالبنك.
      <br /> <br />
    </p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <thead>
        <tr aria-hidden="true"></tr>
        <tr>
          <th aria-hidden="true"></th>
          <th>2020</th>
          <th>2021</th>
          <th>2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>إدماج الموظفين (نسبة مئوية)</td>
          <td>بنك ساب: 58% <br />البنك الأول: 72%</td>
          <td>%56</td>
          <td>%73</td>
        </tr>
      </tbody>
    </table>
    </div>
    <p className="text-paragraph">
      بالإضافة إلى تسجيل مستوى إدماج الموظفين، فقد سلط استطلاع عام 2022 الضوء كذلك ما يلي:
      <br />
      <ul>
        <li>
          %73 من الموظفين راضون عن وتيرة التطور المستمر لثقافة بنك الأول ومستوى الإدماج به، بزيادة قدرها 17% عن عام 2022          
        </li>
        <li>
          %77 من إجمالي الموظفين أكدوا على وعيهم الشديد والتزامهم الراسخ باستراتيجية البنك، بزيادة قدرها 14% عن عام 2022
        </li>
      </ul>
      <br />
      <br />
      يأخذ بنك الأول تعقيبات الموظفين على محمل الجد، وخاصة في ظل التطور الحالي الحاصل في ثقافة البنك. بعد الاندماج الذي شهده البنك في 2019 مع البنك الأول، استغل بنك الأول الفرصة لإعادة تقييم ثقافته التنظيمية مراعياً في الوقت ذاته التركيبة السكانية للمملكة وما تشهده من تحول في الأعراف الاجتماعية. وقد أجرى البنك استطلاعاً بشأن الثقافة المؤسسية بهدف استقاء الرؤى بشأن القرارات المستقبلية الملائمة لثقافة الموارد البشرية. وقد مثلت النتائج التي أسفر عنها التقييم أساساً جيداً تنطلق منه الجهود الرامية لبناء ثقافة تنظيمية جديدة تعتمد على إرث كلتا الشركتين المندمجتين. أطلقنا في عام 2022 مبادرة على مستوى الشركة تمهيداً لإقامة ثقافة تنظيمية تتوافق مع هوية العلامة التجارية لبنك الأول.
      <br /><br />
      يعد تطوير إمكانات الموظفين والارتقاء بمستوى تميزهم سمة أساسية للثقافة التنظيمية لبنك الأول حاضرة في كيفية تعيين الموظفين والاحتفاظ بهم والشروع في تطويرهم. يكون الاعتماد في تعيين الموظفين وترقيتهم على الجدارة والقدرة في ظل بيئة مفتوحة وداعمة تتوفر لجميع الموظفين بها القدرة على الازدهار. وانطلاقاً من الروح التي تسري بالمؤسسة والتي تهدف إلى السعي لتعزيز الاندماج، فإننا نسعى دائماً إلى التماس آراء الموظفين بشأن وضع حلول الأعمال الخاصة بمكان العمل من أجل إقامة بيئة عمل نابضة بالحياة. وفقاً لتصنيف لينكد إن لأفضل الشركات لعام 2022، جاء بنك الأول ضمن أفضل أماكن العمل لبناء المسار الوظيفي بالمملكة العربية السعودية.
      <br />
      <br /><br />
      علاوة على ذلك، فإن هناك العديد من السمات الأخرى التي تجعل من بنك الأول مكان عمل جذاباً، وتشمل:
      <ul>
        <li>
          وجود استراتيجية مكافآت شاملة تتضمن الأجر الثابت ومجموعة شديدة التنوع من المزايا بالإضافة إلى العلاوات والحوافز
        </li>
        <li>
          التزام بتوظيف المواطنين، وهو ما يتضح من ارتفاع نسبة الموظفين من المواطنين السعوديين من 47% في عام 1990 إلى أكثر من 90% في عام 2022
        </li>
        <li>
          توافر مجموعة من الفرص للتدريب والتطوير للموظفين تُعد من أفضل الفرص المتاحة بالقطاع المصرفي بالمملكة
        </li>
        <li>
          امتلاك حزمة مكافآت جذابة تخضع للمراجعة بصفة دورية لضمان استمرار قدرتنا على المنافسة في السوق
        </li>
        <li>
          التوفير المستمر للفرص لاكتساب مهارات جديدة من خلال برامج التعلم التي تعتمد على تعاوننا مع إتش إس بي سي كوننا مجموعة مصرفية دولية رائدة
        </li>
        <li>توفير برامج تدريبية متخصصة للموظفين ذوي الإمكانات العالية.</li>
      </ul>
      <br /><br />
      تتضمن ثقافتنا التنظيمية القيم الأربع المعيارية المتمثلة في التركيز على العملاء والتعاون والابتكار واتخاذ الإجراءات الصحيحة؛ وهي القيم التي تقبع في قلب جميع ما يقوم به البنك. وتحضر هذه القيم الرئيسية دائماً في إطار الحرص على التميز في تقديم الخدمات بداية من مساعدة العملاء في شراء أول منزل لهم وصولاً إلى تحديد المواعيد مع العناصر القيادية العليا، وبداية من اختيار البائع المناسب لنظم تقنية المعلومات المستقبلية ووصولاً إلى تقييم أداء الموظفين. 
      <br /><br />
      وعلى صعيد آخر، نوفر بالبنك مجموعة من المكافآت المجزية للموظفين تخضع للتحديث باستمرار، كما عكفنا على إعادة تشكيل خطط الحوافز والعلاوات لدينا لتحفيز الموظفين على تحقيق أفضل النتائج للعملاء. يخضع مستوى أداء الموظفين للقياس اعتماداً على المخرجات المرتبطة بمستوى رضا العملاء. ويتماشى النهج المتبع لدينا في تكريم الموظفين ومكافآتهم مع قواعد البنك المركزي السعودي المعنية بالتعويضات ومع الإرشادات التوجيهية لمجلس الاستقرار المالي.
      <br /><br />
      بعد اندماج بنك ساب مع البنك الأول، عقد البنك شراكة مع أكسنتشر لتنفيذ أول مبادرة من نوعها للصحة العقلية في قطاع الخدمات المصرفية بالشرق الأوسط، وهي المبادرة التي انطوت على عقد ما يقرب من 50 ندوة عبر الإنترنت حول الصحة العقلية والوعي. وقد جاءت هذه المبادرة في الوقت المناسب للتعامل مع التبعات النفسية التي خلفتها جائحة كورونا نتيجة للآثار الاجتماعية المؤسفة التي صاحبت الجائحة.
      <br />
      <br />
      شهد عام 2022 إطلاقنا لمجموعة من الجلسات المخصصة مع رئيس مجلس الإدارة تحت عنوان "Connect with Tony" (التق بتوني)، مما أتاح للموظفين الالتقاء بالعضو المنتدب والرئيس التنفيذ شخصياً والانخراط في محادثات حول التوجه المستقبلي للبنك. وقد تلا الإطلاق الناجح لهذه الجلسات توسع البنك في نطاق الاجتماعات لتشمل لجنة الإدارة. استضاف بنك الأول أكثر من 10 فعاليات على مستوى المناطق التي يعمل بها، بما في ذلك حفل موسيقي لا يُنسى مثل تجربة فريدة من نوعها وحظي بنسبة رضا من الموظفين تفوق 90%.
      <br />
      <br />
      ويتضمن تقويم فعاليات الموظفين الأخرى، المصممة للتعبير عن الإشادة ولتقديم الدعم مع رفع مستوى الوعي بالقضايا المهمة، لقاءً للتعارف مع فنتك السعودية، وندوة اليوم العالمي للمرأة، وبرنامج الابتكار المقدم " SAB INNOVATE" من بنك الأول. شهد عام 2022 تكريم بنك الأول لعدد 637 موظفاً لوصولهم إلى مراحل رئيسية في عدد سنوات العمل لدى البنك حيث أتموا 5 و10 و15 و20 و25 و30 من السنوات في عام 2021.
      <br />
      ويعمل البنك باستمرار على وضع الأهداف والمراحل الرئيسية بهدف تعزيز شكل ثقافة بيئة العمل التي ينشدها بما يتماشى مع النمو الذي يشهده البنك وتشهده المملكة ككل.
      <br />
    </p>
    <Separator />
    <h4 className="text-title-gray-background">
      التدريب والتطوير الوظيفي
    </h4>
    <p className="text-paragraph">يوضح الجدول التالي التدريب الذي يحصل عليه موظفونا العاملون بدوام كامل، ولا يشمل التدريب الإلزامي والإضافي المنعقد من خلال منصتي لينكد إن وكورسيرا.</p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <thead>
        <tr></tr>
        <tr>
          <th className="mw-50">التدريب</th>
          <th className="mw-50">2020<sup>1</sup></th>
          <th className="mw-50">2021</th>
          <th className="mw-50">2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>إجمالي أنشطة التدريب المنفذة (بالأيام)<sup>2</sup></td>
          <td>1,043</td>
          <td>9,201</td>
          <td className="bg-light-red">9,783</td>
        </tr>
        <tr>
          <td>إجمالي أنشطة التدريب المنفذة (بالساعات)<sup>3</sup></td>
          <td>6,255</td>
          <td>55,206</td>
          <td className="bg-light-red">58,700 <sup className="red-text a-mark">&#9398;</sup></td>
        </tr>
        <tr>
          <td>- موظفو الإدارة العليا </td>
          <td>25</td>
          <td>71</td>
          <td className="bg-light-red">101</td>
        </tr>
        <tr>
          <td>- موظفو الإدارة الوسطى</td>
          <td>110</td>
          <td>975</td>
          <td className="bg-light-red">1,104</td>
        </tr>
        <tr>
          <td>- الموظفون من غير الإدارة</td>
          <td>128</td>
          <td>1,673</td>
          <td className="bg-light-red">1,441</td>
        </tr>
        <tr>
          <td>- الموظفون الذكور</td>
          <td>160</td>
          <td>2,134</td>
          <td className="bg-light-red">2,005</td>
        </tr>
        <tr>
          <td>- الموظفات الإناث</td>
          <td>103</td>
          <td>585</td>
          <td className="bg-light-red">641</td>
        </tr>
        <tr>
          <td>متوسط التدريب لكل موظف (بالأيام)</td>
          <td>0.25</td>
          <td>2.48</td>
          <td className="bg-light-red">2.6</td>
        </tr>
        <tr>
          <td>- موظفو الإدارة العليا</td>
          <td>0.17</td>
          <td>0.51</td>
          <td className="bg-light-red">0.60</td>
        </tr>
        <tr>
          <td>- موظفو الإدارة الوسطى</td>
          <td>0.08</td>
          <td>0.79</td>
          <td className="bg-light-red">0.82</td>
        </tr>
        <tr>
          <td>- الموظفون من غير الإدارة</td>
          <td>0.049</td>
          <td>1.2</td>
          <td className="bg-light-red">0.65</td>
        </tr>
        <tr>
          <td>- الموظفون الذكور</td>
          <td>0.049</td>
          <td>0.73</td>
          <td className="bg-light-red">0.61</td>
        </tr>
        <tr>
          <td>- الموظفات الإناث</td>
          <td>0.12</td>
          <td>0.74</td>
          <td className="bg-light-red">0.76</td>
        </tr>
        <tr>
          <td>متوسط التدريب لكل موظف (بالساعات)</td>
          <td>20</td>
          <td>36</td>
          <td className="bg-light-red">36</td>
        </tr>
        <tr>
          <td>عدد الحضور الذين أتموا دورة تدريبية واحدة على الأقل بنظام التعليم الإلكتروني</td>
          <td>4,045</td>
          <td>3,705</td>
          <td className="bg-light-red">3,709</td>
        </tr>
        {/* <tr>
          <td>Number of e-learning training hours delivered</td>
          <td>0</td>
          <td>0</td>
          <td className="bg-light-red">0</td>
        </tr> */}
        <tr>
          <td>عدد الموظفين الذين أتموا برنامج التعليم الإلكتروني للوعي بالاستدامة</td>
          <td></td>
          <td></td>
          <td className="bg-light-red"></td>
        </tr>
        <tr>
          <td>- الوحدة 1 للممارسات البيئية والاجتماعية والحوكمة المؤسسية</td>
          <td>0</td>
          <td>0</td>
          <td className="bg-light-red">2,633</td>
        </tr>
        <tr>
          <td>- الوحدة 2 للممارسات البيئية والاجتماعية والحوكمة المؤسسية</td>
          <td>0</td>
          <td>0</td>
          <td className="bg-light-red">2,484</td>
        </tr>
      </tbody>
    </table>
    </div>
    <p className="text-note">
    <sup className="red-text a-mark">&#9398;</sup>خضع معيار القياس للسنة المنتهية في 31 ديسمبر 2022 لتأكيد محدود ومستقل من جانب شركة برايس ووترهاوس كوبرز ("PwC")، وللحصول على تفاصيل إضافية، يُرجى الاطلاع على معايير إعداد التقارير لدينا وتقرير التأكيد المحدود لشركة بي دبليو سي عبر زيارة الموقع الإلكتروني (الرابط).<br />
    <sup>1</sup>نتيجة لجائحة كورونا، انعقد عدد أقل من الدورات التدريبية خلال عام 2020. <br />
    <sup>2</sup> إجمالي عدد ساعات التدريب سنوياً / عدد الساعات لكل دورة تدريبية (6 ساعات). <br />
    <sup>3</sup> إجمالي عدد ساعات التدريب سنوياً المستخرجة من حلول إدارة التعلم (LMS).
    </p>
    <p className="text-paragraph">
      يحرص بنك الأول على رفع مستوى المهارات لدى موظفيه وفقاً لمتطلبات البنك، وذلك بعد إجراء تحليل لاحتياجات التعلم ينطوي كذلك على إحداث التوازن مع الأهداف الشخصية للموظفين. تضمنت الأنشطة التدريبية التي قدمناها في عام 2022 ما يلي: <br />
      <ul>
        <li>
          ورشة عمل مخصصة للبيع المتقاطع لمديري علاقات الأعمال والعناصر القيادية في الخطوط الأمامية
        </li>
        <li>
          برنامج بنك الأول لقيادة المخاطر المؤسسية لأفضل 30 مسؤولاً تنفيذياً بالبنك
        </li>
        <li>
          برنامج تسريع الوصول إلى المناصب القيادية، وهو برنامج لصغار المديرين يستهدف إعداد المشاركين لاحتلال المناصب الإدارية العليا
        </li>
        <li>برنامج بنك الأول للدراسات العليا</li>
        <li>برامج الممارسات البيئية والاجتماعية والحوكمة المؤسسية وبرامج التعلم الرقمي</li>
        <li>
        لا تشمل بيانات التدريب أعلاه الأنشطة التدريبية على منصتي لينكد إن وكورسيرا والتدريبات الإلزامية 
        </li>
      </ul>{" "}
      <br /> <br />
      ركزنا بشكل خاص على رفع مستوى الوعي والمهارات في مجالات الحوكمة البيئية والاجتماعية و المؤسسية على جميع المستويات بالبنك في عام 2022. وقد حصلت العناصر القيادية العليا بالبنك على تدريب خارج مقر الشركة بشأن الموضوعات المتعلقة الحوكمةالبيئية والاجتماعية والمؤسسية وكيفية ارتباطها بالبنك وبالمملكة ككل. كما حصل مديرو العلاقات للخدمات المصرفية للشركات في بنك الأول الذين يعملون في قطاع النفط والغاز على تدريب حول الحوكمة البيئية والاجتماعية والمؤسسية تمحور حول اتجاه الأنشطة المالية في هذا القطاع. علاوة على ذلك، تم تدشين وحدات للتعلم الإلكتروني معنية الحوكمة البيئية والاجتماعية والمؤسسية للموظفين على جميع المستويات بالبنك - وقد أتم حتى الآن 70% من الموظفين هذا التدريب.
    </p>
    <Separator />
    <h4 className="text-title-gray-background">تخطيط التطوير</h4>
    <p className="text-paragraph">
      يُمثل تخطيط التطوير في بنك الأول عملية مستمرة بين الموظف والمدير المباشر وتهدف إلى اكتساب المعرفة وصقل المهارات وتزويد الموظفين بفرص التقدم في مسيرتهم المهنية، كما يتماشى تخطيط تطوير الموظفين مع كل من احتياجات المؤسسة والتطلعات المهنية الفردية.
      <br /><br /> 
      تتوفر خطط التطوير لجميع الموظفين، فيوفر بنك الأول إطاراً للموظفين ومديريهم للمساعدة في تقديم أنشطة التطوير المناسبة والمشاركة فيها، مما يُثمر عن دعم تقدم الموظفين وعملية التعاقب. وتتضمن عملية تخطيط التطوير أنشطة التدريب الرسمي وأنشطة التدريب بالتناوب / أثناء العمل والتعرض للعمليات التنظيمية التي تتداخل فيها أقسام متعددة.
    </p>
    <p className="text-paragraph">
    تركز خطة التطوير على تحديد ثلاث فجوات محتملة ومعالجتها: هناك 3 مجالات رئيسية تركز عليها خطة التنمية؛ ألا وهي: 
    </p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary">
      <thead>
        <tr></tr>
        <tr>
          <th>الفجوة الرئيسية</th>
          <th>الوصف</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>المعرفة التقنية</td>
          <td>قد يفتقر الشخص إلى المستوى الكافي من المعرفة والخبرة العملية بشأن جميع المنتجات والوظائف في نطاق دوره الحالي أو المستهدف، بما في ذلك ديناميكيات السوق ذات الصلة بالمنتجات أو الوظائف، أو العملاء، أو البيانات المالية، أو إدارة المخاطر، أو الامتثال اللوائح، وما إلى ذلك.</td>
        </tr>
        <tr className="bg-blue">
          <td>المعرفة التنظيمية</td>
          <td>قد يفتقر الشخص إلى المستوى الكافي من المعرفة والخبرة العملية بشأن جميع أشكال الروابط التنظيمية الداخلية والخارجية المتعلقة بدورهم الحالي أو المستهدف، بما في ذلك البيع المتقاطع، وأوجه الاعتماد المتبادل بين أقسام الأعمال المراقبة الدعم، والعلاقات مع الجهات التنظيمية، وملتقيات العملاء، وأجهزة صناعة القرار (مثل التسلسل الهرمي، والعمليات، واللجان).</td>
        </tr>
        <tr>
          <td>متطلبات القيادة</td>
          <td>قد يفتقر الشخص إلى المستوى الكافي من التعرض لأنشطة الإدارة للفرق الأكبر والأكثر تعقيداً فيما يتعلق بدوره الحالي أو المستهدف، حيث تكون الديناميكيات المرتبطة بوضع الرؤية، وتحقيق التنوع والشمول، والتنظيم، والمشاركة، والتحفيز، وإدارة التغيير أكثر تعقيداً بشكل عام في سياق الفرق الأكبر حجماً.</td>
        </tr>
      </tbody>
    </table>
    </div>
    <h4 className="text-title-gray-background">مزايا الموظفين</h4>
    <p className="text-paragraph">
      يوفر بنك الأول لموظفيه الدعم بمجموعة من المزايا المصممة لتعزيز مستوى السعادة وتمتعهم بصحة جيدة. يتحدد تطبيق المزايا بحسب النطاق الوظيفي العالمي (Global Career Band) للموظفين، والذي يتضمن التحديد بداية من كبار الموظفين (المستوى GCB 0) وصولاً إلى أصغرهم (المستوى GCB 8). وتتضمن المزايا ما يلي:
    </p>
    
    <TabsViewTwo
      headers={[
        "البدلات والتمويل",
        "الإجازات",
        "التأمين الطبي",
        "مزايا أخرى",
      ]}
      data={[
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">بدل تعليم الأطفال</h3>
          <p className="text-paragraph">
            يكون الموظفون من المستوى GCB 0 إلى المستوى GCB 4 مؤهلين لتلقي دعم التعليم لما يصل إلى أربعة أطفال من عمر 5 سنوات إلى 19 سنة بغض النظر عن مكان تعليمهم.
            <br /> <br />
            والبدل المخصص لكل طفل سنوياً هو على النحو التالي:
            <ul>
              <li>المستوى GCB 4: 20 ألف ريال سعودي</li>
              <li>المستوى GCB 1 إلى المستوى GCB 3: 25 ألف ريال سعودي</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">بدل الرعاية النهارية</h3>
          <p className="text-paragraph">
          يحق لجميع الموظفات ممن لديهن أطفال تقل أعمارهم عن ست سنوات الحصول على هذا البدل.
          <br />والبدل المخصص لكل طفل سنوياً هو 12,000 ريال سعودي.
          </p>
          <Separator />
          <h3 className="text-title red-text">تمويل المنازل</h3>
          <p className="text-paragraph">
            بالإضافة إلى بدل السكن الشهري الذي يحصل عليه موظفو بنك الأول (البالغ 25% من الراتب الأساسي)، يُقدم البنك كذلك برنامج "تيسير" لتمويل المنازل المخصص للموظفين السعوديين ممن عليهم قروض قائمة خاصة بالمنازل. يدعم البرنامج الموظفين المؤهلين من خلال سداد تكاليف التمويل التي تزيد عن 1% للعقارات المؤهلة.
          </p>
        </>,
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">الإجازة السنوية</h3>
          <p className="text-paragraph">
          يستحق جميع الموظفين إجازة سنوية على النحو التالي: 
            <ul>
              <li>من المستوى GCB 0 إلى GCB 6: 30 يوم عمل في السنة</li>
              <li>من المستوى GCB 7 إلى GCB 8: 26 يوم عمل في السنة</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">الإجازة المرضية</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين الحصول على إجازة في حالة الإصابة بمرض شديد يمنعهم من العمل، وذلك على النحو التالي:
            <ul>
              <li>إجازة تصل إلى 30 يوماً بأجر كامل</li>
              <li>ثم تكون بثلاثة أرباع الأجر للستين يوماً التالية،</li>
              <li>ثم بنصف الأجر للثلاثين يوماً التالية،</li>
              <li>ثم بربع الأجر للستين يوماً التالية.</li>
            </ul>
            وتكون الإجازة المرضية غير مدفوعة الأجر لما بعد 180 يوماً.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة إصابة العمل</h3>
          <p className="text-paragraph">
            في حال تعرض الموظف لإصابة عمل، فيحق له الحصول على ما يلي:
            <ul>
              <li>إجازة تصل إلى 60 يوماً بأجر كامل</li>
              <li>ثم تكون بثلاثة أرباع الأجر بداية من 61 يوماً حتى عام.</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">الإجازات الرسمية</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين الحصول على إجازة رسمية بأجر كامل في عيد الفطر وعيد الأضحى ويوم التأسيس واليوم الوطني السعودي.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة الحج</h3>
          <p className="text-paragraph">
            يحق للموظف الذين أمضى عامين في العمل الحصول على إجازة مدفوعة الأجر لمدة ستة أيام بالإضافة إلى إجازة عيد الأضحى مرة واحدة لمرة واحدة فقط.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">الإجازة الوالدية</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين الذين يرزقون بأطفال حديثي الولادة الحصول على إجازة والدية مدفوعة الأجر على النحو التالي:
            <ul>
              <li>14 أسبوعاً تقويمياً للأم،</li>
              <li>وخمسة أيام عمل للأب.</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة الدراسة</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين الذين يواصلون تعليمهم الحصول على إجازة مدفوعة الأجر لمدة خمسة أيام عمل للتركيز في دراساتهم بالإضافة إلى يوم واحد لكل موعد امتحان.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة لأمور عائلية</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين الذين يُفجعون بفقدان أحد أفراد أسرتهم المقربين أو إصابته بمرض خطير الحصول على إجازة مدفوعة الأجر لمدة خمسة أيام عمل.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة العدة</h3>
          <p className="text-paragraph">
            يحق لأي موظفة يتوفى عنها زوجها إجازة عدة مدفوعة الأجر:
            <ul>
              <li>للمسلمات: أربعة أشهر و10 أيام تقويمية</li>
              <li> لغير المسلمات: 15 يوماً تقويمي</li>
            </ul>
          </p>
          <Separator />
          <h3 className="text-title-two red-text">الإجازة الطارئة</h3>
          <p className="text-paragraph">
            رغم سماح بنك الأول للموظفين بأخذ إجازة في الحالات الطارئة، تكون هذه الإجازة غير مدفوعة الأجر.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة الزواج</h3>
          <p className="text-paragraph">
            يحق للموظف الحصول على إجازة مدفوعة الأجر لمدة خمسة أيام عمل بمناسبة زواجه.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">إجازة المرافقة</h3>
          <p className="text-paragraph">
            يحق لجميع الموظفين المتزوجين الحصول على إجازة مدفوعة الأجر لمدة يومي عمل سنوياً.
          </p>
        </>,
        <>
          <h3 className="text-paragraph">يوفر بنك الأول تغطية التأمين الطبي التالية للموظفين بحسب المزايا والمعايير التي يحددها شريكنا المختص بالتأمين الطبي والمتعهد بالتأمين.</h3>
          <Separator />
          <h3 className="text-title-two red-text">
            الدعم الطبي الأسري للموظفين المتوفين
          </h3>
          <p className="text-paragraph">
            يوفر بنك الأول أسعاراً خاصة مخفضة في إطار التغطية التأمينية الطبية للموظفين السعوديين لدعم معاليهم في حال وفاة الموظف. وسيواصل البنك تسجيل المعالين وتغطية الأقساط التأمينية لمدة عامين بعد الوفاة.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">تأمين الحوادث الشخصية</h3>
          <p className="text-paragraph">
            يحظى جميع الموظفين بالتغطية حتى سن 65 عاماً (فأكثر، بناءً على اختبارات وموافقات طبية خاصة محددة) بموجب وثيقة التأمين ضد الحوادث الشخصية للمجموعات ضد الوفاة والعجز الدائم أو الجزئي الناتج عن المرض أو الحوادث أثناء استخدام أي وسيلة نقل للانتقال لأغراض العمل أو للأغراض الخاصة. في حالة إصابة الموظف بإعاقة دائمة أو وفاته، يتم سداد مبلغ إجمالي يتراوح بين 500,000 ريال سعودي و5 ملايين ريال سعودي.
            <br />
            للموظفين خيار الحصول على تغطية إضافية للتأمين على الحياة أو العجز.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">تأمين المسؤولية العامة</h3>
          <p className="text-paragraph">
          يوفر هذا التأمين التغطية ضد المسؤولية القانونية عن الأضرار والتكاليف والمصروفات التي يتكبدها مقدم المطالبة فيما يتعلق بالإصابة العرضية التي تقع للموظفين وكذلك الأضرار العرضية التي تقع للممتلكات، وذلك بخلاف إصابات الموظفين أو أي مطالبة تنشأ بموجب نظام العمل السعودي.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">التأمين ضد الأخطار المهنية لدى المؤسسة العامة للتأمينات الاجتماعية</h3>
          <p className="text-paragraph">
            توفر المؤسسة العامة للتأمينات الاجتماعية، بموجب نظام التأمينات الاجتماعية السعودي، لجميع الموظفين تغطية تأمينية إلزامية ضد الإصابات الناتجة عن الحوادث المرتبطة بالعمل على هيئة تعويض.
            <br /> 
            وتكون التغطية وفق ما هو محدد للموظفين من المواطنين السعوديين والوافدين.
          </p>
        </>,
        <>
          <div className="space-25"></div>
          <h3 className="text-title-two red-text">العمل عن بعد</h3>
          <p className="text-paragraph">
            يلتزم بنك الأول بالتأكد من أن ممارسات العمل ومواقع العمل الفعلي وساعات العمل لديه توفر جميعها للموظفين المرونة والاستقلالية التي تلبي احتياجات العمل والموظفين على حد سواء.
            <br /> 
            وفي هذا الإطار، يُدرك بنك الأول أنه يُمكن من خلال تحقيق المزيد من التوازن بين العمل والحياة الشخصية تحقيق مستوى أفضل لتحفيز الموظفين وأدائهم وإنتاجيتهم مع خفض مستوى التوتر.
          </p>
          <Separator />
          <h3 className="text-title-two red-text">الانتقال بين الوظائف</h3>
          <p className="text-paragraph">
            يُشجع بنك الأول على الانتقال الداخلي بين الوظائف ويوفر فرص التطوير المهني لجميع الموظفين من خلال الانتقالات بين الوظائف على المستوى الداخلي بين مختلف المجالات والأقسام. تتم إدارة عمليات الانتقال بين الوظائف من خلال قنوات توفير الموارد البشرية الداخلية، وهي العمليات التي تدعم أنشطة التطوير المهني المستمر لجميع الموظفين وتدعم البنك في تلبية احتياجاته من الموارد.
          </p>
        </>,
      ]}
    />
    <div className="space-50"></div>
    <Separator />
    <div className="space-50"></div>
    <h4 className="text-title-gray-background">العودة بعد الإجازة الوالدية </h4>
    <p className="text-paragraph">يُعد معدل العودة إلى العمل بعد الإجازة الوالدية من مقاييس إدماج الموظفين. وقد شهد البنك تحسناً في معدلات العودة إلى العمل في عام 2022.</p>
    <div className="wrapper-mxw-720 rtl">
    <table className="table-secondary ">
      <thead>
        {/* <tr></tr> */}
        <tr className="border-bottom-red">
          <th>الإجازة الوالدية</th>
          <th>2020</th>
          <th>2021</th>
          <th>2022</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>عدد الموظفات المستفيدات من الإجازة الوالدية</td>
          <td>34</td>
          <td>39</td>
          <td className="bg-light-red">27</td>
        </tr>
        <tr>
          <td>عدد الموظفات العائدات إلى العمل بعد انتهاء اجازة الأمومة (العودة إلى العمل)</td>
          <td>28</td>
          <td>34</td>
          <td className="bg-light-red">26</td>
        </tr>
        <tr>
          <td>عدد الموظفات العائدات من إجازة الأمومة وهن ما زلن موظفات 12 شهراً بعد العودة إلى العمل (الاستبقاء)</td>
          <td>28</td>
          <td>34</td>
          <td className="bg-light-red">26</td>
        </tr>
        <tr>
          <td>معدل العودة إلى العمل (نسبة مئوية)</td>
          <td>%82</td>
          <td>%87</td>
          <td className="bg-light-red">%96</td>
        </tr>
        <tr>
          <td>معدل الاستبقاء (نسبة مئوية)</td>
          <td>%18</td>
          <td>%13</td>
          <td className="bg-light-red">%4</td>
        </tr>
      </tbody>
    </table>
    </div>
    <h4 className="text-title-gray-background">عدم التمييز</h4>
    <p className="text-paragraph">يحصل كل موظف على دورة تعليمية إلكترونية إلزامية سنوية بشأن التعامل مع المضايقات في مكان العمل والإبلاغ عنه، وهي الدورة التي أتمها 98.03% من الموظفين في عام 2022. وتتوفر للموظفين العديد من الجهات التي يُمكنهم رفع شكاواهم أو الإبلاغ عن مخاوفهم إليها. علاوة على ذلك، يوفر البنك لفريق العاملين لديه خطاً ساخناً للإبلاغ عن المخالفات في حال شعور أي موظف بتعرضه هو أو زملائه للتمييز أو المضايقات، وسيوفر كذلك فريقاً مستقلاً للتحقيق مدرباً على الاستجابة لهذه الحوادث بطريقة مستقلة وموضوعية. كما يُطبق البنك كذلك سياسة رسمية للتعامل مع الشكاوى تتعامل الإدارة بموجبها مع الشكاوى المرفوعة على النحو المناسب، مع خضوع حالات معينة لإشراف لجان إدارة المخاطر وإدارة السلوك.</p>
    <div className="tabs-image-wrapper">
      <img src={Social6} alt={"Soclial one wallpapper"} className="tab-wallpaper-image" />
    </div>
  </>,
];

export default tabsViewOneData;
